import { Service } from './types';

export const serviceMock: Service = {
  name: ``,
  slug: ``,
  excerpt: {
    excerpt: ``,
  },
  icon: {
    description: ``,
    gatsbyImageData: {
      height: 60,
      width: 60,
      layout: `fullWidth`,
      placeholder: {
        fallback: ``,
      },
      images: {
        fallback: {
          sizes: ``,
          src: ``,
          srcSet: ``,
        },
        sources: [
          {
            sizes: ``,
            srcSet: ``,
            type: ``,
          },
        ],
      },
    },
  },
  animatedStart: {
    svg: {
      originalContent: ``,
    },
  },
  animated: {
    svg: {
      originalContent: ``,
    },
  },
};
